"use client";

import { useEffect, useRef, useState } from "react";

import { JUDGING } from "./data";

/** Weight bars that fill from zero when scrolled into view (reduced-motion: instant). */
export function JudgingBars() {
  const ref = useRef<HTMLDivElement>(null);
  const [filled, setFilled] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setFilled(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setFilled(true);
            observer.disconnect();
          }
        }
      },
      { threshold: 0.3 },
    );
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={ref}
      className="border-marketing-border divide-marketing-border divide-y border-t"
    >
      {JUDGING.map((c) => (
        <div key={c.title} className="py-5">
          <div className="flex items-baseline justify-between gap-4">
            <h3 className="text-marketing-text text-heading-16! font-medium! text-balance">
              {c.title}
            </h3>
            <span className="text-marketing-text font-mono text-[15px] tabular-nums">
              {c.weight}
              <span className="text-marketing-text-secondary">%</span>
            </span>
          </div>
          <div className="bg-marketing-border-light mt-3 h-[6px] w-full overflow-hidden rounded-full">
            <div
              className="bg-marketing-blue h-full rounded-full transition-[width] duration-[900ms] ease-out motion-reduce:transition-none"
              style={{ width: filled ? `${c.weight}%` : "0%" }}
            />
          </div>
          <p className="text-marketing-text-muted text-copy-14 mt-3 max-w-[58ch]">
            {c.body}
          </p>
        </div>
      ))}
    </div>
  );
}
